var _defs, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVrMedicalLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322.85,
    height: 55.03,
    "data-name": "Layer 1",
    viewBox: "0 0 322.85 55.03",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{isolation:isolate;}.cls-3{opacity:0.9;fill:url(#radial-gradient);}.cls-4{fill:#5cc4e6;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -278.38,
    cy: 143.22,
    r: 1.14,
    gradientTransform: "matrix(-52.89 14.32 14.2 52.44 -16665 -3510.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cc4e6",
    stopOpacity: 0.9,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cc4e6",
    stopOpacity: 0,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transport",
    className: "cls-1",
    transform: "translate(-61.89,-197.54)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m210.38 247.42-1.92-26.34-8.25 25.08h-6.76l-8.25-25.16-2 26.4h-7.54l2.75-38.22h7.65v0.05l1.87-0.05 8.91 27 8.85-27 1.87 0.05v-0.05h7.59l2.8 38.22z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.94 241.37c3.58 0 5.39-1.26 6.66-3.57l6.21 4.12c-2.25 3.3-6 6.21-13.09 6.21-9.4 0-15.51-6.54-15.51-15.17a15 15 0 0 1 15-15.18 14.52 14.52 0 0 1 14.91 14.57 22.16 22.16 0 0 1-0.17 3.08h-21.76a7.53 7.53 0 0 0 7.75 5.94zm6.49-11.27c-0.77-3.8-3.3-6.16-7-6.16s-6.49 2.2-7.31 6.16z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.67 207.22v40.2h-7.53v-3a11.79 11.79 0 0 1-8.91 3.68c-8.36 0-14.41-6.54-14.41-15.17s5.88-15.18 14.19-15.18a12 12 0 0 1 8.52 3.19v-13.72zm-7.81 25.78c0-4.73-3-8-7.48-8s-7.48 3.41-7.48 8 3.14 8 7.48 8 7.48-3.31 7.48-8z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.06 209a5.31 5.31 0 0 1 10.62 0 5.31 5.31 0 0 1-10.62 0zm1.21 9.4h8.14v29h-8.14z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.64 233a14.94 14.94 0 0 1 15.29-15.23c7.86 0 12.7 5.17 14 9.51l-7.25 2.86a6.54 6.54 0 0 0-6.55-5.11c-4.07 0-7.26 3.08-7.26 7.92s3.19 7.92 7.26 7.92a6.67 6.67 0 0 0 6.71-5.06l7.26 2.91c-1.27 4.24-6.1 9.4-14.13 9.4a14.91 14.91 0 0 1-15.33-15.12z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370 218.44v29h-7.53v-3.19a11.21 11.21 0 0 1-8.91 3.9c-8.36 0-14.41-6.54-14.41-15.17s6.05-14.69 14.41-14.69a11.42 11.42 0 0 1 8.91 3.69v-3.52zm-7.82 14.56c0-4.73-3-8-7.47-8s-7.48 3.41-7.48 8 3.13 8 7.48 8 7.47-3.31 7.47-8z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.6 207.22h8.14v40.2h-8.14z",
    fill: "currentColor"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m91.58 53.05-9.35-22.3c6.09-2.43 10.14-7.52 10.14-14.75 0-10.24-7.82-16-18.68-16h-19.73a1.38 1.38 0 0 0-1.32 1l-15 51.78a1.74 1.74 0 0 0 1.19 2.16 1.61 1.61 0 0 0 0.49 0.07h51a1.39 1.39 0 0 0 1.27-1.91z",
    fill: "url(#radial-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m34.11 53.97 15.13-52.23a1.38 1.38 0 0 0-0.94-1.71 1.73 1.73 0 0 0-0.38 0h-43.14a1.38 1.38 0 0 0-1.38 1.37 1.42 1.42 0 0 0 0.08 0.45l17.72 52.25a1.39 1.39 0 0 0 1.31 0.93h10.24a1.4 1.4 0 0 0 1.36-1.06z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrMedicalLogo);
export default __webpack_public_path__ + "static/media/vr-medical-logo.6041f1265e3281b65c4d4dd954f0b1a9.svg";
export { ForwardRef as ReactComponent };